export interface CitationLocation {
  n?: number; chunk_id?: string; book_id?: string; book_title?: string;
  chapter_title?: string; page?: number; text?: string; source_url?: string;
}

/** Use only exact physical pages. A chapter/book navigation is a different action. */
export function citationHref(citation: CitationLocation): string | undefined {
  const {book_id:book,page,chunk_id:chunk}=citation;
  if (!book || !Number.isInteger(page) || page! <= 0) return undefined;
  const path=`/source-page/${encodeURIComponent(book)}/${page}`;
  if (citation.source_url) {
    try {
      const url=new URL(citation.source_url,'https://citation.invalid');
      if (url.origin==='https://citation.invalid' && url.pathname===path && (!chunk || url.searchParams.get('chunk')===chunk)) return path+url.search;
    } catch { /* Regenerate only from validated location fields below. */ }
  }
  return path+(chunk ? `?chunk=${encodeURIComponent(chunk)}` : '');
}

export function citationEntryName(text?: string): string {
  return text?.match(/(?:^|\n)资源名称[：:]\s*([^\n]+)/u)?.[1]?.trim() || '';
}
